<span class="ds-chip" [class.active]="active" (click)="onCheck(value)">
  <span class="ds-caption-2">
    <ng-content></ng-content>
  </span>
</span>
